



























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
// import AOS from 'aos'
// import 'aos/dist/aos.css';
// AOS.init();

// interfaces

// components
import L3onlineLandingPage from "@/components/LandingPage/L3onlineLandingPage.vue";
import L3schreinerLandingPage from "@/components/LandingPage/L3schreinerLandingPage.vue";
import L3johannesbadLandingPage from "@/components/LandingPage/L3johannesbadLandingPage.vue";
import L3vincenzLandingPage from "@/components/LandingPage/L3vincenzLandingPage.vue";
import L3rnHeroHeader from "@/components/LandingPage/L3rnHeroHeader.vue";
import L3VincenzHeroHeader from "@/components/LandingPage/L3VincenzHeroHeader.vue";

const ux = namespace("ux");

@Component({
  components: {
    L3onlineLandingPage,
    L3schreinerLandingPage,
    L3johannesbadLandingPage,
    L3vincenzLandingPage,
    L3rnHeroHeader,
    L3VincenzHeroHeader
  }
})
export default class LandingPage extends Vue {
  @ux.State darkTheme: any;
  @ux.State customer: any;

  // Customers with an own landing page, every other customer gets the L3RN-online one
  get isL3schreiner(): boolean {
    return this.customer === "schreiner";
  }

  get isL3johannesbad(): boolean {
    return this.customer === "johannesbad";
  }

  get isL3vincenz(): boolean {
    return this.customer === "vincenz";
  }

  get isL3online(): boolean {
    return !this.isL3schreiner && !this.isL3johannesbad && !this.isL3vincenz;
  }

  // Position of the server hint box (Test System, Pilot, Local) over the header
  get hintBoxAlign(): string {
    // Vincenz: the bottom right is covered by the drawing of the clinic, the top right is free
    return this.isL3vincenz ? "start" : "end";
  }

  get hintBoxStyle(): any {
    const style: any = { position: "absolute", inset: "0", paddingRight: "30px", width: "100%", height: "100%", zIndex: 2 };
    if (this.isL3vincenz)
      style.paddingTop = "30px";
    else
      style.paddingBottom = "60px";
    return style;
  }

  mounted() {
    this.applyOrAdjustDigiClassTheme();
  }

  metaInfo() {
    return {
      titel: "L3RN online Home",
      meta: [
        {
          name: "description",
          content: "Die kostengünstige Schulungs-App"
        }
      ]
    }
  }

  applyOrAdjustDigiClassTheme() {
    // adjust old style
    let themeLink = document.getElementById('exerciseTheme');
    if (themeLink) {
      if (this.darkTheme)
        themeLink.setAttribute("href", "/styles/exercises-dark.css");
      else
        themeLink.setAttribute("href", "/styles/exercises-light.css");

      return;
    }

    // Create new one
    let styles = document.createElement('link');
    styles.type="text/css";
    styles.rel="stylesheet";
    styles.id="exerciseTheme";
    if (this.darkTheme)
      styles.href="/styles/exercises-dark.css";
    else
      styles.href="/styles/exercises-light.css";
    document.head.appendChild(styles);
  }

  get lightTransparentColor() {
      return this.$store.state.ux.colorAccent5 + "40";
  }

  get showLeftImage1() {
    return true;
  }

  get showLeftImage2() {
    return false;
  }

  get showRightImage1() {
    return this.$vuetify.breakpoint.xsOnly;
  }

  get showRightImage2() {
    return !this.$vuetify.breakpoint.xsOnly;
  }
}
